
            window.versions = {
                script: 35,
                atlas: {
                    preloader: 1,
                    core: 2,
                    "core-ui": 2,
                    lobby: 2,
                    competition: 3,
                    popup: 1,
                    "popup-shop": 1,
                },
                layout: 9,
                sound: 2,
                font: 1,
                ambience: 1,
                descriptor: 9,
                image: 3
            };

            import(/* @vite-ignore */__ENTRY_FILE__);
        